import React from 'react';
import { Link, Radio, Typography, SkeletonLine, } from '@one-thd/sui-atomic-components';
import { RETURN_METHOD } from '@src/constants/general';
import { CheckEligibilityMap, ReturnAllowedMap, } from '@src/utils/eligibility-utils';
export var InStoreReturnMethodDescription = function (hostname, isMilitaryExchangeGuest) { return (React.createElement(React.Fragment, null,
    "Take your items to any",
    ' ',
    React.createElement(Link, { href: "https://".concat(hostname, "/l/"), target: "_blank", variant: "body-sm" }, "Home Depot store"),
    ". Show your barcode",
    !isMilitaryExchangeGuest && React.createElement(React.Fragment, null, ", receipt or the card used at purchase"),
    " to an associate at the returns counter.")); };
export var UpsDropOffReturnMethodDescription = (React.createElement(React.Fragment, null,
    "Pack your items in a box and drop them off at",
    ' ',
    React.createElement(Link, { href: "https://www.ups.com/dropoff?loc=en_US", target: "_blank", variant: "body-sm" }, "select UPS location"),
    ' ',
    "using your barcode."));
export var LORPReturnMethodDescription = (React.createElement(React.Fragment, null, "Schedule a pickup, and The Home Depot will collect your large item(s)."));
export var ReturnMethodOption = function (_a) {
    var returnMethodName = _a.returnMethodName, returnMethodHeader = _a.returnMethodHeader, returnMethodDescription = _a.returnMethodDescription, onChange = _a.onChange;
    return (React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
        React.createElement("div", { className: "sui-flex" },
            React.createElement("div", { className: "sui-block" },
                React.createElement(Radio, { value: returnMethodName, id: returnMethodName, onChange: onChange })),
            React.createElement("label", { htmlFor: returnMethodName },
                React.createElement("div", { className: "sui-ml-2" },
                    React.createElement(Typography, { uppercase: true }, returnMethodHeader),
                    React.createElement(Typography, { variant: "body-sm" }, returnMethodDescription)))),
        React.createElement(Typography, { className: "sui-justify-self-end", weight: "bold", variant: "body-sm" }, "FREE")));
};
export var getReturnMethodEligibility = function (orderDetailsV2, returnEligibilityData) {
    // Order Level Flag checks
    var returnInStoreAllowed = false;
    var returnDropoffAllowed = false;
    var returnLORPAllowed = false;
    // from OMS, If return eligibility is not allowed for in-store, hide the in-store option
    if (orderDetailsV2.returnInStoreAllowed) {
        returnInStoreAllowed = true;
    }
    // from OMS, If return eligibility is not allowed for UPS, hide the UPS option
    if (orderDetailsV2.returnOnlineAllowed ||
        orderDetailsV2.returnDropoffAllowed) {
        returnDropoffAllowed = true;
    }
    // from OMS, If return eligibility is not allowed for LORP, hide the LORP option
    if (orderDetailsV2.returnLORPAllowed) {
        returnLORPAllowed = true;
    }
    // check if any of the OMS-ELIGIBLE line items for LORP are also CheckEligibilityAPI-ELIGIBLE
    if (!checkAnyItemEligible(orderDetailsV2.lineItems, returnEligibilityData, RETURN_METHOD.LORP)) {
        returnLORPAllowed = false;
    }
    // same for in-store returns
    if (!checkAnyItemEligible(orderDetailsV2.lineItems, returnEligibilityData, RETURN_METHOD.UPS_DROP_OFF)) {
        returnDropoffAllowed = false;
    }
    // same for in-store returns, but only until SORIS is 4reals...
    return { returnInStoreAllowed: returnInStoreAllowed, returnDropoffAllowed: returnDropoffAllowed, returnLORPAllowed: returnLORPAllowed };
};
export var ReturnMethodSkeletonLoader = function () { return (React.createElement("div", { className: "sui-mt-4", "data-testid": "method-skeleton" },
    React.createElement(SkeletonLine, { variant: "multi", numberOfLines: 2 }))); };
export var checkAnyItemEligible = function (lineItems, returnEligibilityData, returnMethod) {
    var showMethodBtn = false;
    var eligibilityField = CheckEligibilityMap[returnMethod];
    var omsEligibleField = ReturnAllowedMap[returnMethod];
    var filteredLineItems = lineItems.filter(function (item) {
        if (returnMethod === RETURN_METHOD.UPS_DROP_OFF) {
            return item.returnDropoffAllowed || item.returnOnlineAllowed;
        }
        return item[omsEligibleField];
    });
    if (
    // if at least 1 filtered item is eligible in checkEligibility, show the return method
    filteredLineItems === null || filteredLineItems === void 0 ? void 0 : filteredLineItems.some(function (item) {
        var _a, _b;
        return (_b = (_a = returnEligibilityData === null || returnEligibilityData === void 0 ? void 0 : returnEligibilityData.lineItems) === null || _a === void 0 ? void 0 : _a.find(function (eligibilityItem) { return eligibilityItem.lineNumber === item.lineId; })) === null || _b === void 0 ? void 0 : _b[eligibilityField];
    })) {
        showMethodBtn = true;
    }
    return showMethodBtn;
};
